// App Imports
import { MESSAGE_SHOW, MESSAGE_HIDE, MODAL_SHOW, MODAL_HIDE } from './actions'

// Initial State
export const commonInitialState = {
  message: {
    text: [],
    open: false,
    duration: 5000
  },
  modal: {
    open: false,
    title: '',
    text: '',
    queue: []
  }
}

// State
const state = (state = commonInitialState, action) => {
  switch (action.type) {
    case MESSAGE_SHOW:
      return {
        ...state,
        message: {
          text: action.message?.text ? action.message.text : action.message,
          duration: (action.message?.duration === null) ? null : 5000,
          open: true
        }
      }

    case MESSAGE_HIDE:
      return {
        ...state,
        message: {
          text: [],
          open: false
        }
      }
    
    case MODAL_SHOW:
       if (state.modal.open) {
        return {
         ...state,
         modal: {
           ...state.modal,
           queue: [...state.modal.queue, action.message]
        }
        };
     } else {
      return {
        ...state,
        modal: {
          open: true,
          title: action.message.title,
          text: action.message.text,
          queue: state.modal.queue
        }
      };
    }

    case MODAL_HIDE:
      if (state.modal.queue.length > 0) {
        const [nextModal, ...restQueue] = state.modal.queue;
        return {
          ...state,
          modal: {
            open: true,
            title: nextModal.title,
            text: nextModal.text,
            queue: restQueue
          }
        };
      } else {
        return {
          ...state,
          modal: {
            open: false,
            title: '',
            text: '',
            queue: []
          }
       };
     }

    default:
      return state
  }
}
export default state;